"use client";

import React, { useEffect } from "react";
import { UnhandledErrorPage } from "@components/organisms/errors/UnhandledErrorPage";
import { posthogCaptureException } from "@features/shared/posthog";

type GlobalErrorProps = {
    error: Error & { digest?: string };
    reset: () => void;
};

export default function GlobalError({ error }: GlobalErrorProps) {
    useEffect(() => {
        console.error(error);
        // The console is gone by the time anyone looks; keep the stack where it can be found.
        posthogCaptureException(error, {
            digest: error.digest,
            boundary: "global-error",
            path: typeof window !== "undefined" ? window.location.pathname : undefined
        });
    }, [error]);

    return (
        <html lang="en">
            <body className="min-h-dvh overflow-x-hidden">
                <UnhandledErrorPage />
            </body>
        </html>
    );
}
